module.exports = __webpack_public_path__ + "static/Gobi Desert-f760a0c433ddec4520b57254f3781c13.jpg";